/* index.js */

"use strict";
module.exports = require("./AdvancedFilterWrapper");
